// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const TypesCloudProvider = {
  GCP: 'gcp',
  AWS: 'aws',
  Azure: 'azure',
} as const;
export type TypesCloudProvider =
  (typeof TypesCloudProvider)[keyof typeof TypesCloudProvider];

export function instanceOfTypesCloudProvider(value: any): boolean {
  for (const key in TypesCloudProvider) {
    if (Object.prototype.hasOwnProperty.call(TypesCloudProvider, key)) {
      if (
        TypesCloudProvider[key as keyof typeof TypesCloudProvider] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function TypesCloudProviderFromJSON(json: any): TypesCloudProvider {
  return TypesCloudProviderFromJSONTyped(json, false);
}

export function TypesCloudProviderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesCloudProvider {
  return json as TypesCloudProvider;
}

export function TypesCloudProviderToJSON(
  value?: TypesCloudProvider | null,
): any {
  return value as any;
}

export function TypesCloudProviderToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): TypesCloudProvider {
  return value as TypesCloudProvider;
}
